/**
 * @file An wrapper of a breeze entity changed subscription so we can comply with the rxjs ISubscription interface.
 * @author Tom Verschoore de la Houssaije.
 */
/**
 * An wrapper of a breeze entity changed subscription so we can comply with the rxjs ISubscription interface.
 * @export
 * @class EntityChangedSubscription
 * @implements {ISubscription}
 */
var EntityChangedSubscription = /** @class */ (function () {
    /**
     * Creates an instance of EntityChangedSubscription.
     * @param {EntityManager} manager The entity manager of a BreezeService is needed to unsubscribe the subscription.
     * @param {number} entityChangedSubscription Reference to breeze subscription. Is used to unsubscribe.
     */
    function EntityChangedSubscription(manager, entityChangedSubscription) {
        this.manager = manager;
        this.entityChangedSubscription = entityChangedSubscription;
        /**
         * Holds the value indicating whether or not the subscription is closed.
         * @private
         */
        this._closed = false;
    }
    /**
     * Unsubscribes a breeze entity changed subscription by the rxjs ISubscription interface.
     */
    EntityChangedSubscription.prototype.unsubscribe = function () {
        if (this.entityChangedSubscription) {
            this.manager.entityChanged.unsubscribe(this.entityChangedSubscription);
            this.entityChangedSubscription = undefined;
            this.manager = null;
            this._closed = true;
        }
    };
    Object.defineProperty(EntityChangedSubscription.prototype, "closed", {
        /**
         * Gets the indication for rxjs whether or not the subscription is closed.
         * @readonly
         * @type {boolean}
         */
        get: function () {
            return this._closed;
        },
        enumerable: true,
        configurable: true
    });
    return EntityChangedSubscription;
}());
export { EntityChangedSubscription };
